import { Subject, BehaviorSubject } from 'rxjs';
import { AppLayer } from './layer.service';
import * as i0 from "@angular/core";
var ActivityService = /** @class */ (function () {
    function ActivityService() {
        this.hoverCoord = new Subject();
        this.displayedLayerListBS = new BehaviorSubject({
            layers: []
        });
        this.selectedLayerBS = new BehaviorSubject({
            layer: null
        });
        this.bgRefLayerChange = new Subject(); // bg ref change
        this.parentLayerBS = new BehaviorSubject(null);
        this.mapFilterBS = new BehaviorSubject({
            isOn: false
        });
        this.mapFilterDisableBS = new BehaviorSubject({
            disabled: false
        });
        this.mapMoveProcessingBS = new BehaviorSubject(null);
        // selectedRecord: BehaviorSubject<{id: string; source?: 'table' | 'map' | 'card'}> = new BehaviorSubject(null);
        this.selectedRecordsBS = new BehaviorSubject(null);
        this.currentCardBS = new BehaviorSubject(null);
        this.editRecordListBS = new BehaviorSubject({
            // list: []
            ids: []
        });
        this.editRecordHoldListBS = new BehaviorSubject({
            ids: []
        });
        this.editRecordListHiddenBS = new BehaviorSubject({
            // list: []
            ids: []
        });
        this.stackAddressesSelectBS = new BehaviorSubject({});
        this.selectedTabBS = new BehaviorSubject({
            tabKey: null
        });
        this.batchFilterCount = new BehaviorSubject({
            count: null
        });
        this.applyAttrFilterSubject = new Subject();
        this.refreshData = new Subject();
        this.cancelChangesSubject = new Subject();
        this.networkTopoMode = new BehaviorSubject({
            isOn: true
        });
        // Is current data sample
        this.isDataSample = new BehaviorSubject(true);
        this.updateExceptionsSubject = new Subject();
        this.resetFeatures = new Subject();
        this.changeTabSubject = new Subject();
    }
    ActivityService.prototype.removeCurrentSelection = function () {
        var selection = this.selectedRecordsBS.getValue();
        if (selection && selection.ids && selection.ids.length) {
            this.selectedRecordsBS.next({
                ids: []
            });
        }
    };
    ActivityService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ActivityService_Factory() { return new ActivityService(); }, token: ActivityService, providedIn: "root" });
    return ActivityService;
}());
export { ActivityService };
